export default __webpack_public_path__ + "static/media/help-drawer-header-2x.dbe0f967.png";